import { render, staticRenderFns } from "./PgcRank.vue?vue&type=template&id=8c7a2010&"
import script from "./PgcRank.vue?vue&type=script&lang=js&"
export * from "./PgcRank.vue?vue&type=script&lang=js&"
import style0 from "./PgcRank.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports